import { useState } from 'react';
import { useVerifyFtpCredentials } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { VerifyFtpCredentials } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';

interface IFtpCredentials {
  data?: VerifyFtpCredentials;
  isVerified: boolean;
  error: boolean;
  isLoading: boolean;
}

const useVerifyFtpCredentialsLogic = () => {
  const [ftpCredentials, setFtpCredentials] = useState<IFtpCredentials>({
    data: undefined,
    isVerified: false,
    error: false,
    isLoading: false,
  });

  const verifyFTP = useVerifyFtpCredentials();

  const checkIfVerified = (data: VerifyFtpCredentials) => {
    return Object.keys(data).every(
      (k: string) => data[k as keyof typeof data]?.verified,
    );
  };

  const handleVerify = () => {
    setFtpCredentials({
      ...ftpCredentials,
      isLoading: true,
    });
    verifyFTP({
      environments: ['development', 'staging', 'production'],
    })
      .then(({ data }) => {
        if (data) {
          setFtpCredentials({
            data,
            isVerified: checkIfVerified(data),
            error: false,
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        setFtpCredentials({
          ...ftpCredentials,
          error: true,
          isLoading: false,
        });
        console.log(err);
      });
  };

  return { handleVerify, ftpCredentials };
};

export default useVerifyFtpCredentialsLogic;
